import * as React from 'react'
import { useEffect } from 'react'
import { Box, Grid } from '@mui/material'

import { COMPONENTS } from './@constants'
import { filterComponents } from '@signals/commonFilters'
import CommonFiltersFooterActions from '@components/NewCommonFilters/FooterActions'
import { ShowFeatures } from '@components/CommonFilters/@components'
import { showFeatures } from '@signals'
import AppFilterPanel, { filterPanelGridSx } from '@components/@base/FilterPanel'
import { dsColorNew } from '@palette'

// Fields that render nothing (an optional office, a group the user did not pick) leave no hole in the grid.
const fieldsGridSx = { ...filterPanelGridSx(), '& > .MuiGrid-item:empty': { display: 'none' } }

export default function AppCommonFilters(
	{
		components = [],
		featuresComponents = [],
		headerComponents = [],
		Footer = CommonFiltersFooterActions,
	}) {

	useEffect(() => {
		filterComponents.value = components.map((comp) => comp.name)
	}, [components])

	const renderComponents = (items) =>
		items.map(({ name, grid = {}, ...props }, idx) => {
			if (name === "blank") return null
			const Component = COMPONENTS[name]
			if (!Component) return null
			return (
				<Grid key={idx} item xs={4} {...grid}>
					<Component {...props} />
				</Grid>
			)
		})

	// The toggles above the fields sit in one row, without the grid widths they had.
	const renderToggles = (items) =>
		items.map(({ name, grid, ...props }, idx) => {
			const Component = COMPONENTS[name]
			return Component ? <Component key={idx} {...props} /> : null
		})

	return <AppFilterPanel
		toggles={headerComponents.length > 0 && renderToggles(headerComponents)}
		togglesRight={featuresComponents.length > 0 && <ShowFeatures/>}
		actions={<Footer/>}
	>
		<Box sx={fieldsGridSx}>{renderComponents(components)}</Box>
		{featuresComponents.length > 0 && showFeatures.value && <Box sx={{ ...fieldsGridSx, mt: 2.25, pt: 2.25, borderTop: `1px dashed ${dsColorNew.grayBorder}` }}>
			{renderComponents(featuresComponents)}
		</Box>}
	</AppFilterPanel>
}
